import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-content">
        <img src="/images/logo.jpeg" alt="Manami Trading" className="loader-logo" />
        <div className="loader-spinner"></div>
      </div>
    </div>
  );
};

export default Loader;
